/**
 * Stub nodes inserted before the author saves real condition text stay out of Tree/Grid stacks.
 */

const PLAN_NODE_DRAFT_TITLES = new Set([
  'New prerequisite',
  'New condition',
  'Desired outcome',
]);

/** True until the condition has non-empty saved text ≠ known stub titles. */
export function isPlanNodeAwaitingFirstSave(text: string | undefined | null): boolean {
  const t = (text ?? '').trim();
  if (t === '') return true;
  return PLAN_NODE_DRAFT_TITLES.has(t);
}
